import React, { Component } from 'react';
import { Modal, Header, Button, Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';
import * as _ from 'lodash';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { TrackedCheckbox } from '../../../components';

let assingedAllergies = [];

class AllergenModal extends Component {
  submitAllergenData = () => {
    const { allergenData, studentModalData, saveAllergen } = this.props;

    _.filter(allergenData, (x) => {
      if (x.Assigned === 1) {
        assingedAllergies.push(x.AllergenId);
        return null;
      }
    });
    const assignObj = {
      Id: studentModalData.Id,
      AllergenIds: assingedAllergies,
    };
    saveAllergen(assignObj);
    assingedAllergies = [];
  };

  render() {
    const {
      showAllergenModal,
      studentModalData,
      updateAllergenData,
      checkAll,
      onClose,
    } = this.props;
    let { allergenData } = this.props;
    if (allergenData && allergenData.data === '') {
      allergenData = [];
    }
    return (
      <Modal
        open={showAllergenModal}
        onClose={onClose}
        closeIcon
        size={'small'}
        closeOnRootNodeClick={false}
      >
        <Header
          content={`Assign Allergen - ${studentModalData.FirstName} ${studentModalData.LastName}`}
          icon={'food'}
        />
        <Modal.Content className="p-t-0">
          <ReactTable
            data={allergenData}
            defaultPageSize={15}
            showPageSizeOptions={false}
            defaultFilterMethod={caseInsensitiveFilter}
            onFilteredChange={() => {
              this.setState({ checkAllChecked: false });
            }}
            defaultSorted={[
              {
                id: 'Description',
                desc: false,
              },
            ]}
            columns={[
              {
                Header: 'Allergen',
                accessor: 'Description',
                resizable: true,
                filterable: true,
              },
              {
                Header: ({ data }) => {
                  return (
                    <span>
                      <Checkbox
                        checked={
                          data.length > 0 &&
                          data.every((s) => s._original.Assigned)
                        }
                        onClick={(e, checkbox) => {
                          checkAll(checkbox.checked ? 1 : 0, data);
                        }}
                      />
                    </span>
                  );
                },

                accessor: 'Assigned',
                maxWidth: 120,
                sortable: true,
                Cell: ({ original }) => {
                  const { initialAllergenData } = this.props;
                  const initialValue =
                    initialAllergenData.find(
                      (x) => x.AllergenId === original.AllergenId
                    ).Assigned === 1;

                  return (
                    <div style={{ textAlign: 'center' }}>
                      <TrackedCheckbox
                        checked={original.Assigned === 1}
                        initialValue={initialValue}
                        onChange={() => {
                          updateAllergenData(original);
                        }}
                      />
                    </div>
                  );
                },
              },
            ]}
          />
        </Modal.Content>
        <Modal.Actions>
          <SecurityPreferences scope={PrefEnum.AssignAllergens}>
            {(disabled) => {
              return (
                <Button
                  onClick={this.submitAllergenData}
                  inverted
                  color="orange"
                  size="big"
                  content="Save"
                  disabled={disabled}
                />
              );
            }}
          </SecurityPreferences>
        </Modal.Actions>
      </Modal>
    );
  }
}

export { AllergenModal };



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/AllergenModal.js